/**
 * APO 上传缩略图点击查看大图（配合 sections/main-product.liquid 挂载）
 *
 * 背景：Mageworx APO 的上传缩略图（.mw-filepond-custom-item）由第三方脚本动态渲染，
 * 后台无法配置点击预览，只能在前端补一层交互。
 * 方案：document 级事件委托（动态新增/重渲染的缩略图无需重新绑定），
 * 点击 .mw-filepond-custom-thumb 时取其 img 的 src 弹出全屏大图，
 * 点击遮罩 / 关闭按钮 / Esc 关闭。样式由 JS 注入，不依赖主题 CSS 是否加载。
 */
(function () {
  'use strict';

  var OVERLAY_ID = 'lp-apo-thumb-lightbox';
  // 非图片文件（如 PDF）不弹大图，文件名取自 .mw-filepond-custom-name
  var IMAGE_EXT_RE = /\.(png|jpe?g|gif|webp|bmp|svg|avif|heic|heif)$/i;

  function injectStyle() {
    if (document.getElementById(OVERLAY_ID + '-style')) return;
    var style = document.createElement('style');
    style.id = OVERLAY_ID + '-style';
    style.textContent = [
      '.mw-filepond-custom-thumb{cursor:zoom-in}',
      '#' + OVERLAY_ID + '{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:5vmin;background:rgba(0,0,0,.85);cursor:zoom-out}',
      '#' + OVERLAY_ID + '.is-open{display:flex}',
      '#' + OVERLAY_ID + ' .lp-apo-thumb-lightbox__img{max-width:92vw;max-height:92vh;width:auto;height:auto;object-fit:contain;border-radius:8px;box-shadow:0 10px 40px rgba(0,0,0,.4);cursor:default}',
      '#' + OVERLAY_ID + ' .lp-apo-thumb-lightbox__close{position:absolute;top:16px;right:16px;width:40px;height:40px;border:none;border-radius:50%;background:rgba(255,255,255,.15);color:#fff;font-size:22px;line-height:1;cursor:pointer}',
      '#' + OVERLAY_ID + ' .lp-apo-thumb-lightbox__close::before{content:"\\00d7"}',
      'body.lp-apo-thumb-lightbox-open{overflow:hidden}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  function getOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<button type="button" class="lp-apo-thumb-lightbox__close" aria-label="Close preview"></button>' +
      '<img class="lp-apo-thumb-lightbox__img" alt="">';

    // 点击遮罩空白处或关闭按钮关闭；点在大图上不关闭
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.lp-apo-thumb-lightbox__close')) closeOverlay();
    });

    document.body.appendChild(overlay);
    return overlay;
  }

  function openOverlay(src, alt) {
    var overlay = getOverlay();
    var img = overlay.querySelector('.lp-apo-thumb-lightbox__img');
    img.alt = alt || '';
    img.src = src;
    overlay.classList.add('is-open');
    document.body.classList.add('lp-apo-thumb-lightbox-open');
  }

  function closeOverlay() {
    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('lp-apo-thumb-lightbox-open');
    var img = overlay.querySelector('.lp-apo-thumb-lightbox__img');
    if (img) img.removeAttribute('src');
  }

  // 捕获阶段监听并阻断冒泡，避免误触发 APO 自身可能的点击逻辑；
  // 缩略图上的删除按钮（.mw-filepond-custom-remove）不在 .mw-filepond-custom-thumb 内，不受影响。
  function onDocumentClick(e) {
    var thumb = e.target && e.target.closest ? e.target.closest('.mw-filepond-custom-thumb') : null;
    if (!thumb) return;
    var img = thumb.querySelector('img');
    if (!img) return;

    var item = thumb.closest('.mw-filepond-custom-item');
    var name = item && item.querySelector('.mw-filepond-custom-name');
    var title = (name && (name.getAttribute('title') || name.textContent)) || img.alt || '';
    if (title && !IMAGE_EXT_RE.test(title)) return;

    e.preventDefault();
    e.stopPropagation();
    openOverlay(img.getAttribute('src') || img.currentSrc, title);
  }

  injectStyle();
  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });
})();
